import { createFileRoute, redirect } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";
import { AccountPage } from "./account";

export const Route = createFileRoute("/console")({
  head: () => ({
    meta: [
      { title: "Choose Portal — Currency Thoughts" },
      { name: "robots", content: "noindex" },
    ],
  }),
  beforeLoad: async () => {
    const { data } = await supabase.auth.getSession();
    if (!data.session) {
      throw redirect({ to: "/login" });
    }
  },
  component: AccountPage,
});